import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export const LandingCTA = () => {
  return (
    <section className="relative w-full min-h-[468px] py-16 md:py-24 px-6 md:px-12 flex flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-[#4A4E69] via-[#4A4E69] to-[#3a3e59]">
      {/* Animated Blobs */}
      <div
        className="absolute top-0 left-[15%] w-[600px] h-[600px] rounded-full opacity-20 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(255, 209, 102, 0.6) 0%, rgba(255, 209, 102, 0) 70%)",
          animation: "drift 20s ease-in-out infinite",
        }}
      ></div>
      <div
        className="absolute bottom-0 right-[10%] w-[500px] h-[500px] rounded-full opacity-15 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(216, 222, 233, 0.5) 0%, rgba(216, 222, 233, 0) 70%)",
          animation: "drift 28s ease-in-out infinite reverse",
        }}
      ></div>

      {/* Overlay pattern */}
      <div
        className="absolute inset-0 opacity-[0.02] -z-10"
        style={{
          backgroundImage: "radial-gradient(circle, white 1px, transparent 1px)",
          backgroundSize: "30px 30px",
        }}
      ></div>

      {/* Content */}
      <div
        className="relative z-10 flex flex-col items-center max-w-4xl mx-auto"
        style={{
          animation: "fadeInUp 0.8s ease-out",
        }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-4">
          Pronto(a) para dar o primeiro passo?
        </h2>

        <p
          className="text-xl md:text-2xl text-white/90 text-center mb-8"
          style={{
            animation: "fadeInUp 0.8s ease-out 0.2s backwards",
          }}
        >
          A clareza que sua mente merece.
        </p>

        <div
          className="relative group"
          style={{
            animation: "fadeInUp 0.8s ease-out 0.4s backwards",
          }}
        >
          {/* Glow effect behind button */}
          <div
            className="absolute inset-0 rounded-full opacity-50 group-hover:opacity-100 transition-opacity duration-500 blur-2xl -z-10"
            style={{
              background: "radial-gradient(circle, rgba(255, 209, 102, 0.8), transparent 70%)",
              transform: "scale(1.5)",
            }}
          ></div>

          <Link to="/auth?tab=signup">
            <Button
              size="lg"
              className="h-14 px-12 rounded-full bg-[#FFD166] hover:bg-[#FFD166]/90 text-[#4A4E69] text-lg font-bold shadow-2xl transition-all duration-300 hover:scale-110 hover:shadow-[0_20px_60px_rgba(255,209,102,0.5)]"
            >
              <span className="transition-transform duration-300 group-hover:scale-105">Testar agora</span>
            </Button>
          </Link>
        </div>

        <p
          className="text-sm text-white/80 mt-4 flex items-center gap-2"
          style={{
            animation: "fadeInUp 0.8s ease-out 0.6s backwards",
          }}
        >
          <span className="inline-block w-1 h-1 rounded-full bg-[#FFD166] animate-pulse"></span>
          Sem cartão • Sem compromisso
        </p>
      </div>

      <style>{`
        @keyframes drift {
          0%, 100% { 
            transform: translate(0, 0) scale(1); 
          }
          50% { 
            transform: translate(50px, 50px) scale(1.15); 
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};
